"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourgumVendorSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.SourgumVendorSchema = {
    name: 'sourgum-vendor',
    alias: 'Sourgum Vendor',
    shortName: 'Hauler',
    applications: ['aap'],
    returnType: {
        aap: transport_types_1.Hauler.HaulerWithAapTransport,
    },
    searchableAttributes: [
        {
            field: 'name',
            alias: 'Hauler Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'contacts.email',
            alias: 'Hauler Email',
            shortName: 'Email',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            field: 'active',
            type: 'BOOLEAN',
            alias: 'Active',
            shortName: 'Active',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        {
            field: 'isSourgumPartner',
            type: 'BOOLEAN',
            alias: 'Sourgum Partner',
            shortName: 'Sourgum Partner',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        ...meta_data_1.MetaDataFilters,
    ],
    extraMappings: [],
};
//# sourceMappingURL=sourgum-vendor.js.map